/* eslint-disable prettier/prettier */
import { clsx } from 'clsx'
import { PropertyValueMap,unsafeCSS } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { html } from 'lit/static-html.js'

import { DdsElement } from '../../../../internal/dds-hu-element'
import styles from '../../../icon/_styles/icon.scss?inline'

/**
 * `dap-ds-icon-tools-line`
 * @summary An icon
 * @element dap-ds-icon-tools-line
 * @title - DesignToolsLine
 * @group icon
 * @icontype design
 * 
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
@customElement('dap-ds-icon-tools-line')
export default class DesignToolsLine extends DdsElement {
  /** (optional) The width and height in pixels */
  @property({ type: Number, reflect: true }) size? = 24
  /** (optional) Sets the icon color via the `fill` attribute */
  @property({ type: Boolean, reflect: true }) selected?: boolean = false
  /** (optional) When using the icon standalone, make it meaningful for accessibility */
  @property() accessibilityTitle?: string
  /** (optional) If `true` the icon can receive focus */
  @property({ type: Boolean }) focusable?: boolean = false

  static readonly styles = unsafeCSS(styles)

  protected firstUpdated(_changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>): void {
    super.firstUpdated(_changedProperties)

    this.classList.add('dap-ds-icon')
  }

  render() {
    return html`
      <svg
        part="base"
        class=${clsx('icon', 'dap-ds-icon-tools-line')}
        xmlns="http://www.w3.org/2000/svg"
        width=${this.size}
        height=${this.size}
        viewBox="0 0 24 24"
        tabindex=${this.focusable ? 0 : -1}
        aria-hidden=${this.ariaHidden ?? 'true'}>
        ${this.accessibilityTitle
          ? html`<title>${this.accessibilityTitle}</title>`
          : null}
        <g part="container">
          <g>
            <path d="M5.33 3.272a3.5 3.5 0 0 1 4.254 4.962l10.709 10.71-1.414 1.414-10.71-10.71a3.502 3.502 0 0 1-4.962-4.255L5.444 7.63a1.5 1.5 0 0 0 2.121-2.121zm10.367 1.883 3.182-1.768 1.414 1.415-1.768 3.181-1.768.354-2.12 2.121-1.415-1.414 2.121-2.121zm-6.718 8.132 1.415 1.414-5.304 5.303a1 1 0 0 1-1.492-1.327l.078-.087z"></path>
          </g>
        </g>
      </svg>
    `
  }
}
